import { NetworkData } from "../fstn/network";

export function getNodesInRoot(root: string, networkData: NetworkData)
{
    return Object.keys(networkData.states || {})
        .filter(state => networkData.states[state].parent === root)
}